import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const SECTIONS = [
  {
    title: 'Éditeur du site',
    content: `MY RESTO — Société à responsabilité limitée (SARL) au capital de 10 000,00 €\nImmatriculée au RCS de Chambéry sous le numéro SIREN 797 530 185 (SIRET siège : 797 530 185 00025)\nSiège social : 303 Rue de la République, 73000 Chambéry\nNuméro de TVA intracommunautaire : FR13797530185\nGérant et Directeur de publication : Muhamed Ali Yilmaz\nTéléphone : 04 22 91 05 37\nEmail : contact@fouratacos.com`,
  },
  {
    title: 'Hébergement',
    content: `Hébergeur : Google Ireland Limited\nGordon House, Barrow Street\nDublin 4, Irlande\nSite web : firebase.google.com`,
  },
  {
    title: 'Propriété intellectuelle',
    content: `L'ensemble des contenus présents sur ce site (textes, images, vidéos, logos, graphismes) sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de Four a Tacos. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable.`,
  },
  {
    title: 'Données personnelles',
    content: `Les informations recueillies sur ce site sont enregistrées dans un fichier informatisé par Four a Tacos pour la gestion de la relation client. Conformément à la loi « informatique et libertés » et au Règlement Général sur la Protection des Données (RGPD), vous pouvez exercer votre droit d'accès, de rectification ou de suppression en contactant : contact@fouratacos.com.`,
  },
];

export default function MentionsLegales() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Mentions Légales — Four A Tacos';
  }, []);

  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main className="legal-main" style={{ flex: 1 }}>
        <h1 className="legal-title" style={{ marginBottom: '48px' }}>
          MENTIONS LÉGALES
        </h1>

        {SECTIONS.map(({ title, content }) => (
          <section key={title} style={{ marginBottom: '40px' }}>
            <h2 style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '18px', fontWeight: '700', color: '#C10230', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
              {title}
            </h2>
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#4A4A4A', lineHeight: '1.8', margin: 0, whiteSpace: 'pre-line' }}>
              {content}
            </p>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
